import styled from "@emotion/styled";
import { Container } from "@mui/system";
import { customPalette } from "shared/palettes";

export const ContainerStyle = styled(Container)`
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${customPalette.default};
  padding-top: 2rem;
  padding-bottom: 2rem;
  gap: 2rem;
`;
